/**
 * @copyright Copyright (c) Agence ink
 */

//// Module summary ////
// => This module contains the JS required by the projects page (a.k.a réalisations), and its gsap animations

/////////////// GSAP animation modules (Uncomment required gsap library!) /////////////////
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
///////////////////////////////////////////////////////////////////////////////////////////

export const projects = () => {
    const vh = window.innerHeight / 100;

    // WEIRD TRACK ANIMATION
    // -> Creates a horizontal track in which the images' width are dynamic
    // -> The tricky part is to reset the animation on window resize.
    // -> If a window resize is detected, a recursive function is called to check if the resize is done, then recalls the gsap
    let weirdTrack = document.querySelector(".featured-track");
    if (weirdTrack) {
        // Wrapping all the animation code in a function to be recalled on resize
        let initWeirdTrack = () => {
            // Variables
            let images = weirdTrack.querySelectorAll(".div-right");
            let trackWrapper = document.querySelector(".section_projets-featured");
            let trackOffset = -Math.abs(weirdTrack.offsetWidth - window.innerWidth); // When to stop the track

            // Horizontal scroll animation
            let wrapperScroll = gsap.to(weirdTrack, {
                x: trackOffset,
                ease: "none",
                scrollTrigger: {
                    trigger: trackWrapper,
                    start: window.innerHeight + vh * 50 + " bottom", // trigger start for track
                    end: "bottom-=" + vh * 50 + " bottom", // Will stay on screen for a 50vh scroll
                    scrub: 0.5,
                    id: "wt1",
                    markers: false
                }
            });
        
            // Images animation
            for (let current of images) {
                // Remove potential previous gsap
                current.removeAttribute('style');

                let commonScrollTrigger = {
                    trigger: current,
                    containerAnimation: wrapperScroll,
                    start: "top 50%",
                    end: "bottom top",
                    scrub: true,
                    id: "wt2",
                    markers: false
                };

                let imageAnim = {
                    desktop: {
                        width: 0,
                        scrollTrigger: commonScrollTrigger,
                    }, mobile: {
                        x: "15%",
                        scrollTrigger: commonScrollTrigger,
                    }
                };
                
                if (window.innerWidth <= 991) {
                    if (!current.classList.contains('overflow')) {
                        gsap.set(current, {
                            scale: 1.3,
                            x: "-15%",
                        });
                        gsap.to(current, imageAnim.mobile);
                    }
                } else {
                    if (current.classList.contains('overflow')) {
                        gsap.to(current, imageAnim.desktop);
                    }                
                }
            }

            // [ANIMATION] "SEE PROJECT" CTA
            // -> On hover, moves and fades out the project name to the right and reveals a "SEE PROJECT" cta
            // -> We placed it here in initWeirdTrack because it's PART of the weirdTrack ¯\_(ツ)_/¯
            let ctaContainers = document.querySelectorAll('.div-left');
            if (ctaContainers.length > 0) {
                let duration = .2;
                for (let currentContainer of ctaContainers) {
                    let ctaLine = currentContainer.querySelector('[data-gsap="ctaLine"]');
                    if (ctaLine) {
                        gsap.set(ctaLine, { x: 0 });
                        let titleLeft = ctaLine.firstElementChild;
                        let titleRight = ctaLine.lastElementChild;
                        
                        // Move the ctaLine to the left so the right-title is vertically aligned
                        let marginDistance = currentContainer.querySelector('.projet-vedette-content-wrapper').offsetLeft - currentContainer.offsetLeft;
                        let titleDistance = titleRight.getBoundingClientRect().left - currentContainer.getBoundingClientRect().left;
                        let innerDistance = marginDistance - titleDistance;
                        gsap.set(ctaLine, { x: innerDistance });

                        // Anim on mouse enter and leave
                        ctaLine.addEventListener('mouseenter', () => {
                            gsap.to(ctaLine, { x: 0 }); 
                            gsap.to(titleLeft, { autoAlpha: 1, duration: duration });
                            gsap.to(titleRight, { autoAlpha: 0, duration: duration });
                        });

                        ctaLine.addEventListener('mouseleave', () => {
                            gsap.to(ctaLine, { x: innerDistance });
                            gsap.to(titleLeft, { autoAlpha: 0, duration: duration });
                            gsap.to(titleRight, { autoAlpha: 1, duration: duration });
                        });
                    }
                }
            }
        };
        
        // Set the animation on page load
        initWeirdTrack();

        // Recursive function to be called on resize:
        // -> Can only be called once at a time
        // -> Will memorize the current window size and compare it 400 ms apart
        // -> If the size does not move anymore, we can reload the animation.. 
        // -> ..otherwise it calls itself again, as the user is still resizing their browser
        let resizeTriggered = false;
        let olderInnerWidth = window.innerWidth;

        let checkResizeDone = () => {
            if (!resizeTriggered) {
                resizeTriggered = true;
                setTimeout(() => {
                    resizeTriggered = false;
                    if (olderInnerWidth == window.innerWidth) {
                        initWeirdTrack();
                    } else {
                        olderInnerWidth = window.innerWidth;
                        checkResizeDone();
                    }
                }, 400);
            }
        };

        // On window resize, kill the former scrollTrigger to prevent overload, then call the checkResize function
        let currentWidth = window.innerWidth;
        window.addEventListener("resize", () => {
            if (currentWidth !== window.innerWidth) {
                if (ScrollTrigger.getById("wt1")) {
                    ScrollTrigger.getById("wt1").kill();
                    ScrollTrigger.getById("wt2").kill();
                }
                checkResizeDone();
            }
            currentWidth = window.innerWidth;
        });
        
        // Refresh after a certain point
        // Refresh ScrollTrigger when you reach a certain point
        const refreshPoint = document.querySelector('#listing');
        let stRefresh = () => {
            const rect = refreshPoint.getBoundingClientRect();
            if (rect.top <= window.innerHeight) {
                ScrollTrigger.refresh();
                window.removeEventListener('scroll', stRefresh);
            }
        };
        window.addEventListener('scroll', stRefresh);
        
        ///
    }

    return;
};
